import { useMemo } from "react";
import Badge from "../../components/badge";
import Table, { TableColumns } from "../../components/table";
import { SubLoanRepaymentSchedule } from "../../dto";
import { LoanRepaymentScheduleStatusEnum } from "../../models";
import { dateToDDMMYYYY } from "../../utils";

function StatusBadge({ status }: { status: LoanRepaymentScheduleStatusEnum }) {
  if (status === LoanRepaymentScheduleStatusEnum.UNPAID)
    return <Badge type="pending">UNPAID</Badge>;
  if (status === LoanRepaymentScheduleStatusEnum.PAID)
    return <Badge type="success">Paid</Badge>;
  if (status === LoanRepaymentScheduleStatusEnum.PARTIALLY_PAID)
    return <Badge type="success">Partially Paid</Badge>;
  return <Badge type="reject">Rejected</Badge>;
}

interface RetailOdDrawdownLoanRepaymentScheduleProps {
  isLoading: boolean;
  data: SubLoanRepaymentSchedule[] | null;
}

const RETAIL_OD_DRAWDOWN_LOAN_REPAYMENT_SCHEDULE_TABLE_COLUMNS: TableColumns[] =
  [
    {
      label: "Installment No",
      field: "installmentNo",
      style: { textAlign: "center" },
    },
    { label: "Due Date", field: "dueDate", style: { textAlign: "center" } },
    { label: "Amount", field: "amount", style: { textAlign: "center" } },
    { label: "Principal", field: "principal", style: { textAlign: "center" } },
    { label: "Interest", field: "interest", style: { textAlign: "center" } },
    {
      label: "Principal Paid",
      field: "principalRepaidAmount",
      style: { textAlign: "center" },
    },
    {
      label: "Interest Paid",
      field: "interestRepaidAmount",
      style: { textAlign: "center" },
    },
    { label: "Status", field: "status", style: { textAlign: "center" } },
  ];

function getTableDataForRetailOdDrawdownLoanRepaymentSchedule(
  data: SubLoanRepaymentSchedule[]
) {
  return data.map((eachRepaymentSchedule, index) => {
    const {
      dueDate,
      dueAt,
      status,
      principal,
      interest,
      interestRepaidAmount,
      principalRepaidAmount,
    } = eachRepaymentSchedule;
    return {
      installmentNo: index + 1,
      dueDate: dateToDDMMYYYY(dueDate || dueAt),
      amount: Number(principal + interest).toFixed(2),
      principal: principal.toFixed(2),
      interestRepaidAmount: interestRepaidAmount.toFixed(2),
      principalRepaidAmount: principalRepaidAmount.toFixed(2),
      interest: interest.toFixed(2),
      status: <StatusBadge status={status} />,
    };
  });
}

export default function RetailOdDrawdownLoanRepaymentSchedule({
  data,
  isLoading,
}: RetailOdDrawdownLoanRepaymentScheduleProps) {
  const tableDataForRetailOdLoanRepaymentSchedule = useMemo(() => {
    if (!data) return [];
    return getTableDataForRetailOdDrawdownLoanRepaymentSchedule(data);
  }, [data]);

  return (
    <div>
      <h3 className="user-page-title mb-4">Repayment Schedule</h3>
      <Table
        loading={isLoading}
        columns={RETAIL_OD_DRAWDOWN_LOAN_REPAYMENT_SCHEDULE_TABLE_COLUMNS}
        data={tableDataForRetailOdLoanRepaymentSchedule}
      />
    </div>
  );
}
